import { render, staticRenderFns } from "./Response.vue?vue&type=template&id=22d0f5d3&"
import script from "./Response.vue?vue&type=script&lang=js&"
export * from "./Response.vue?vue&type=script&lang=js&"
import style0 from "./Response.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports